import React from 'react'

interface Characteristic {
 value: string
 label: string
}

interface CharacteristicsSelectorProps {
 characteristics: Characteristic[]
 selectedValues: string[]
 onChange: (values: string[]) => void
 className?: string
}

export const CharacteristicsSelector: React.FC<CharacteristicsSelectorProps> = ({
 characteristics,
 selectedValues,
 onChange,
 className = ''
}) => {
 const allSelected = characteristics.every(c => selectedValues.includes(c.value))

 const toggleAll = () => {
 if (allSelected) {
 onChange([])
 } else {
 onChange(characteristics.map(c => c.value))
 }
 }

 const toggleCharacteristic = (value: string) => {
 if (selectedValues.includes(value)) {
 onChange(selectedValues.filter(v => v !== value))
 } else {
 onChange([...selectedValues, value])
 }
 }

 return (
 <div className={className}>
 <div className="flex items-center justify-between mb-3">
 <label className="block text-sm font-medium text-foreground">
 Selecione as características
 </label>
 <button
 type="button"
 onClick={(e) => {
 e.preventDefault()
 e.stopPropagation()
 toggleAll()
 }}
 className="text-sm text-accent hover:text-primary-700 dark:text-accent dark:hover:text-primary-300 font-medium transition-colors"
 >
 {allSelected ? 'Desselecionar Todos' : 'Selecionar Todos'}
 </button>
 </div>
 
 <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
 {characteristics.map((characteristic) => (
 <label 
 key={characteristic.value} 
 className="flex items-center space-x-2 cursor-pointer p-2 hover:bg-surface rounded-md transition-colors"
 onClick={(e) => {
 e.preventDefault()
 e.stopPropagation()
 toggleCharacteristic(characteristic.value)
 }}
 >
 <input
 type="checkbox"
 checked={selectedValues.includes(characteristic.value)}
 onChange={(e) => {
 e.preventDefault()
 e.stopPropagation()
 }}
 onClick={(e) => {
 e.stopPropagation()
 }}
 className="rounded border-border text-accent focus:ring-accent pointer-events-none"
 />
 <span className="text-sm text-foreground">
 {characteristic.label}
 </span>
 </label>
 ))}
 </div>
 </div>
 )
}

